<template>
  <v-container fluid>
    <v-layout align-center justify-center mx-3 mb-2 mt-3>
      <v-flex md9 class="headline">
        Respuestas
      </v-flex>
      <v-flex md3>
        <v-btn class="k-orange-linear white--text" block large @click="dialog = true">Agregar respuesta {{filters.channel.toUpperCase()}}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap mx-3>
      <v-flex md3 pr-2>
        <v-card :class="{'elevation-3':true, 'k-orange-linear':filters.channel === 'email', 'hovered':filters.channel !== 'email'}" height="95px">
          <v-card-text @click="filters.channel = 'email'">
            <v-layout justify-center align-center>
              <v-flex xs4>
                <v-avatar
                  size="60"
                  class="transparent"
                >
                  <v-icon large :class="{'k-orange-linear-text':filters.channel !== 'email', 'white--text':filters.channel === 'email'}">fas fa-envelope</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex xs8>
                <v-layout row wrap>
                  <v-flex xs12 :class="{'headline':true, 'white--text':filters.channel === 'email'}">
                    Email
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 px-2>
        <v-card :class="{'elevation-3':true, 'k-orange-linear':filters.channel === 'whatsapp', 'hovered':filters.channel !== 'whatsapp'}" height="95px">
          <v-card-text @click="filters.channel = 'whatsapp'">
            <v-layout justify-center align-center>
              <v-flex xs4>
                <v-avatar
                  size="60"
                  class="transparent"
                >
                  <v-icon large :class="{'k-orange-linear-text':filters.channel !== 'whatsapp', 'white--text':filters.channel === 'whatsapp'}">fab fa-whatsapp</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex xs8>
                <v-layout row wrap>
                  <v-flex xs12 :class="{'headline':true, 'white--text':filters.channel === 'whatsapp'}">
                    Whatsapp
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 px-2>
        <v-card :class="{'elevation-3':true, 'k-orange-linear':filters.channel === 'facebook', 'hovered':filters.channel !== 'facebook'}" height="95px">
          <v-card-text @click="filters.channel = 'facebook'">
            <v-layout justify-center align-center>
              <v-flex xs4>
                <v-avatar
                  size="60"
                  class="transparent"
                >
                  <v-icon large :class="{'k-orange-linear-text':filters.channel !== 'facebook', 'white--text':filters.channel === 'facebook'}">fab fa-facebook-messenger</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex xs8>
                <v-layout row wrap>
                  <v-flex xs12 :class="{'headline':true, 'white--text':filters.channel === 'facebook'}">
                    Facebook
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md3 pl-2>
        <v-card :class="{'elevation-3':true, 'k-orange-linear':filters.channel === 'sms', 'hovered':filters.channel !== 'sms'}" height="95px">
          <v-card-text @click="filters.channel = 'sms'">
            <v-layout justify-center align-center>
              <v-flex xs4>
                <v-avatar
                  size="60"
                  class="transparent"
                >
                  <v-icon large :class="{'k-orange-linear-text':filters.channel !== 'sms', 'white--text':filters.channel === 'sms'}">fas fa-comment</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex xs8>
                <v-layout row wrap>
                  <v-flex xs12 :class="{'headline':true, 'white--text':filters.channel === 'sms'}">
                    Sms
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <data-table
      url="/answer_templates"
      fields="name,status,template_code,text,voice,type,channel"
      content="answerTemplateLists"
      search-fields="name"
      :filters="filters"
      :dashboard="true"
      :limit="6">
      <template slot="navigation-bar">
        <v-flex md9 pr-1>
          <v-text-field solo label="Buscar.." color="grey" append-icon="fas fa-search" v-model="filters.search"></v-text-field>
        </v-flex>
        <v-flex md3 pl-1>
          <v-select
            v-model="filters.category"
            :items="listCategories"
            item-value="value"
            item-text="category"
            class="white--text"
            label="Ordenar por.."
            color="grey"
            autocomplete
            solo>
          </v-select>
        </v-flex>
      </template>
    </data-table>
    <delete-dialog
      :text="deleteOptions.text"
      :id="deleteOptions.id"
      url="answer_templates"
      :dialog="deleteOptions.dialog"
      :delete-bus="deleteBus">
    </delete-dialog>
    <save-dialog
      :title="title"
      :dialog="dialog"
      :form="form"
      :route="route"
      :edit="edit"
      :hasMore="false"
      :more="false"
      :scrollable="filters.channel == 'email' ? true : false"
      :bus="dialogBus"
      :width="filters.channel == 'email' ? '800px' : '600px'">
      <template slot="content">
        <v-layout row wrap>
          <v-flex md8 pr-5>
            <v-text-field
              v-model="form.name"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-as="nombre"
              :error-messages="errors.collect('name')"
              label="Nombre"
              color="black">
            </v-text-field>
          </v-flex>
          <v-flex md4>
            <v-menu offset-y class="w-100" max-height="250px">
              <v-text-field
                v-model="form.category"
                @input="findCategory"
                slot="activator"
                label="Categoria"
                item-text="category"
                item-value="category"
                v-validate="'required'"
                data-vv-name="category"
                data-vv-as="categoria"
                :error-messages="errors.collect('category')"
                color="black">
              </v-text-field>
              <v-list v-if="categories.length > 0">
                <v-list-tile v-for="item in categories" :key="item.key" @click="form.category = item.category">
                  <v-list-tile-title>{{ item.category }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
              <v-list v-else>
                <v-list-tile>
                  <v-list-tile-title class="grey--text">No se encontraron registros</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-show="filters.channel != 'email'">
          <v-flex md12>
            <div id="textarea-wrapper">
              <textarea
                v-model="form.text"
                v-validate="`required|${form.channel === 'sms' ? 'max:160' : 'max:1000'}`"
                data-vv-name="text"
                data-vv-as="texto"
                placeholder="Texto"
                :class="{'has-error': errors.has('text')}">
              </textarea>
            </div>
            <small :class="{'d-block text-xs-right f1em mt-2': true, 'grey--text': form.text.length <= 160, 'error--text': form.text.length > 160}">
              {{ form.text.length }} / 160
            </small>
            <small class="error--text" v-if="errors.has('text')">
              {{ errors.first('text') }}
            </small>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-show="filters.channel == 'email'">
          <v-flex xs12>
            <vue-editor v-model="text" useCustomImageHandler @imageAdded="handleImageAdded" :editorToolbar="editorToolbar"></vue-editor>
            <small class="error--text" v-if="errors.has('text')">
              {{ errors.first('text') }}
            </small>
          </v-flex>
        </v-layout>
        <v-layout row wrap mt-2>
          <v-flex xs12>
            <v-switch
              label="Respuesta automatica"
              v-model="form.automatic_reply"
              class="k-blue-linear-text">
            </v-switch>
          </v-flex>
        </v-layout>
        <template v-if="form.automatic_reply">
          <v-layout row wrap :class="{'mb-5': form.answer_schedules.length}">
            <v-flex md3 pr-4>
              <v-select
                v-model="automaticReply.day"
                :items="weekDays"
                label="Día"
                v-validate="`included:${weekDays.map(item => item.value).join(',')}`"
                data-vv-name="day"
                data-vv-as="día"
                data-vv-scope="automaticReply"
                :error-messages="errors.collect('day', 'automaticReply')"
                color="grey"
                autocomplete>
              </v-select>
            </v-flex>
            <v-flex md3 offset-md1>
              <v-text-field
                v-model="automaticReply.startHour"
                label="Hora de inicio"
                ref="start_hour"
                prepend-icon="fas fa-clock fa-sm"
                type="time"
                v-validate="automaticReply.day !== null ? 'required|less_than:end_hour' : null"
                data-vv-name="start_hour"
                data-vv-scope="automaticReply"
                :error-messages="errors.collect('start_hour', 'automaticReply')"
                color="black">
              </v-text-field>
            </v-flex>
            <v-flex md3 offset-md1>
              <v-text-field
                v-model="automaticReply.endHour"
                ref="end_hour"
                label="Hora final"
                prepend-icon="fas fa-clock fa-sm"
                type="time"
                v-validate="automaticReply.day !== null ? 'required|bigger_than:start_hour' : null"
                data-vv-name="end_hour"
                data-vv-scope="automaticReply"
                :error-messages="errors.collect('end_hour', 'automaticReply')"
                color="black">
              </v-text-field>
            </v-flex>
            <v-flex md1 text-xs-right pt-2>
              <v-btn icon @click="saveAutomaticReply()">
                <v-icon small class="py-2">
                  fas fa-check
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-for="(schedule, i) in form.answer_schedules" :key="`row-${i}`">
            <v-flex md3 pr-4>
              <small>Día</small>
              <p class="subheading">
                {{ weekDays.filter(item => item.value === schedule.day)[0].text }}
              </p>
            </v-flex>
            <v-flex md3 offset-md1>
              <small>Hora inicio</small>
              <p class="subheading">
                <v-icon class="mr-1">
                  fas fa-clock
                </v-icon>
                {{ schedule.start_hour }}
              </p>
            </v-flex>
            <v-flex md3 offset-md1>
              <small>Hora fin</small>
              <p class="subheading">
                <v-icon class="mr-1">
                  fas fa-clock
                </v-icon>
                {{ schedule.end_hour }}
              </p>
            </v-flex>
            <v-flex md1 text-xs-center>
              <v-btn icon @click="removeAutomaticReply(i)" class="ma-0 mb-3 mt-2">
                <v-icon small class="py-2">
                  fas fa-times
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
      </template>
    </save-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';
import { Validator } from 'vee-validate';
import EventBus from '@/event-bus';
import DataTable from '@/components/global/DataTable';
import answerTemplateLists from '@/components/answer_template/AnswerTemplateList';
import SaveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import DeleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import { VueEditor } from 'vue2-editor';
import emailEditorToolbarMixin from '@/mixins/emailEditorToolbar';

Vue.component('answerTemplateLists', answerTemplateLists);

export default {
  mixins: [
    saveDialogMixin,
    emailEditorToolbarMixin,
    deleteDialogMixin,
  ],
  components: {
    DataTable,
    SaveDialog,
    DeleteDialog,
    VueEditor,
  },
  created() {
    moment.locale('es');

    Validator.extend('less_than', {
      getMessage: () => 'La hora de inicio debe ser menor que la hora fin',
      validate: (value, [endHour]) => {
        const endHourMoment = moment(`2014-01-27 ${endHour}:00`, 'YYYY-MM-DD HH:mm:ss');
        return endHourMoment.isAfter(moment(`2014-01-27 ${value}:00`, 'YYYY-MM-DD HH:mm:ss'), 'minute');
      },
    }, {
      hasTarget: true,
    });
    Validator.extend('bigger_than', {
      getMessage: () => 'La hora fin debe ser mayor que la hora inicio',
      validate: (value, [startHour]) => {
        const startHourMoment = moment(`2014-01-27 ${startHour}:00`, 'YYYY-MM-DD HH:mm:ss');
        return moment(`2014-01-27 ${value}:00`, 'YYYY-MM-DD HH:mm:ss').isAfter(startHourMoment, 'minute');
      },
    }, {
      hasTarget: true,
    });

    this.weekDays = [{
      value: null,
      text: 'Todos',
    }].concat(moment.weekdays().map((item, i) => ({
      value: i,
      text: _.upperFirst(item),
    })));
    this.axios.get('/answer_templates/categories').then((response) => {
      this.categories = response.data;
      this.saveCategories = response.data;
    });
    EventBus.$on('update', this.getCategories);
    this.getCategories();
  },
  destroyed() {
    EventBus.$off('update');
  },
  data() {
    return {
      route: 'answer_templates',
      fields: 'name,text,status,category',
      form: {
        channel: 'email',
        name: '',
        text: '',
        category: '',
        automatic_reply: true,
        answer_schedules: [],
      },
      automaticReply: {
        day: '',
        startHour: '',
        endHour: '',
      },
      weekDays: [],
      saveCategories: [],
      listCategories: [],
      filters: {
        search: '',
        category: '',
        channel: 'email',
      },
      categories: [
        {
          category: 'Categorias',
          value: '',
        },
      ],
      voices: [
        {
          value: 'hombre',
          text: 'Hombre',
        },
        {
          value: 'mujer',
          text: 'Mujer',
        },
      ],
      text: '',
      dialog: false,
    };
  },
  methods: {
    getCategories() {
      this.axios.get(`/answer_templates/categories?channel=${this.filters.channel}`).then((response) => {
        this.listCategories = [{
          category: 'Categorias',
          value: '',
        }].concat(response.data.map(item => ({
          category: _.upperFirst(item.category),
          value: item.category,
        })));
      }).catch(() => {});
    },
    findCategory(search) {
      this.categories = this.saveCategories.filter(item => item.category.match(new RegExp(`.*${search}.*`, 'gi')));
    },
    clearAutomaticReply() {
      Object.keys(this.automaticReply).forEach((key) => {
        this.automaticReply[key] = '';
      });
    },
    saveAutomaticReply() {
      this.$validator.validateAll('automaticReply').then((validation) => {
        if (validation) {
          this.form.answer_schedules.push({
            day: this.automaticReply.day,
            start_hour: this.automaticReply.startHour,
            end_hour: this.automaticReply.endHour,
          });
          this.clearAutomaticReply();
          this.$validator.reset({
            scope: 'automaticReply',
          });
        }
      });
    },
    removeAutomaticReply(index) {
      this.form.answer_schedules.splice(index, 1);
    },
  },
  computed: {
    showName() {
      return `respuesta ${this.filters.channel}`;
    },
  },
  watch: {
    'filters.channel'(newVal) { // eslint-disable-line
      this.form.channel = newVal;
      this.getCategories();
    },
    'form.automatic_reply'() { // eslint-disable-line
      this.clearAutomaticReply();
    },
    'form.text'(newVal) { // eslint-disable-line
      if (this.filters.channel === 'email' && this.text !== newVal) {
        this.text = newVal;
      }
      if (!this.dialog && !newVal) {
        this.text = '';
      }
    },
    'form.channel'(newVal) { // eslint-disable-line
      if (newVal.channel !== this.filters.channel) {
        this.form.channel = this.filters.channel;
      }
    },
    text(newVal) {
      this.form.text = newVal;
    },
  },
};
</script>

<style scoped>
textarea {
  position: relative !important;
}
</style>


// WEBPACK FOOTER //
// src/components/answer_template/Index.vue